import React from 'react';
import './PricingPage.css';

const PricingPage = () => {
  return (
    <div className="pricing-wrapper">
      <section className="pricing-hero">
        <h1>Transparent Pricing for Every Project</h1>
        <p>Custom solutions built for your unique needs</p>
      </section>

      <section className="pricing-content">
        <p>
          At <strong>Redfox Digital</strong>, we believe in providing quality digital solutions at transparent prices. Our pricing typically <strong>starts from ₹5,000</strong> for simple websites and basic services, and can go up to <strong>₹50,000</strong> for full-scale projects including e-commerce, web applications, and marketing automation.
        </p>

        <p>
          However, based on the complexity, features, integrations, and project timeline, pricing may <strong>exceed ₹50,000</strong>. We offer flexible pricing models to match your goals — whether you're a startup, an established business, or a growing brand.
        </p>

        <p>
          Each quote is custom-tailored after a free consultation. We ensure clarity, no hidden charges, and full transparency from day one.
        </p>

        <div className="pricing-note">
          <p>
            Ready to get started? <a href="/contact">Contact us</a> and let's discuss your project.
          </p>
        </div>
      </section>
    </div>
  );
};

export default PricingPage;
